const viewAny = (permissions) => {
  return permissions.includes('read-automation-task')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-automation-task')
}

const update = (permissions, automationTask) => {
  return hasPermission(permissions, 'update-automation-task')
}

const deletee = (permissions, automationTask) => {
  return hasPermission(permissions, 'delete-automation-task')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};